import axios from "./httpService";

export default {
  getToolbarStateApi: () => axios.get("toolbar")
};
